export default __webpack_public_path__ + "static/media/red_icon.037876a4.svg";